import { type ContentComponent, type SalesCategoryContent } from '../../../../../types/construct.types';
import { HomeCarousel } from '../../../../home-components/home-carousel/home-carousel.component';

export const SalesCategoryHandler: ContentComponent<SalesCategoryContent> = ({
	content: {
		fields: {
			sales: { items }
		}
	}
}) => {
	return <HomeCarousel items={items} automationHook="carousel-top-category-swipe" navigationVerticalPosition={-40} />;
};
